import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { i18n, useTranslation } from 'next-i18next'
import { BELGIAN_ENTERPRISE_NUMBER } from 'constants/regex'
import { checkControlDigit } from './utils'

const CompanyNumber = () => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register('companyNumber', {
        pattern: { value: BELGIAN_ENTERPRISE_NUMBER, message: i18n.t('commonFormFields:companyNumber.errors.invalid') },
        required: t('validation:required'),
        validate: (companyNumber: string) => checkControlDigit(companyNumber) || i18n.t('commonFormFields:companyNumber.errors.invalid')
      })}
      error={errors?.companyNumber?.message as string}
      label={t('commonFormFields:companyNumber.label')}
    />
  )
}

export default CompanyNumber
